
// https://stackoverflow.com/questions/46002113/javascript-reactjs-display-image-with-readablestream-as-source

import React, { useEffect, useState } from 'react';
import { AxiosError, AxiosResponse } from 'axios';

import formatDataUrlWithUrl from '../_libs/utils/formatDataUrlWithUrl';
import getImageWithOptions from '../_libs/utils/getImageWithOptions';

export interface AzureImageResponseType {
  status: string | number;
  dataUrl: string;
  url: string;
  message?: string;
}
export interface AzureImageProps {
  alt: string; // Alt-text to be included in web browser
  className?: string; // CSS class names
  id?: string;
  ref?: any;
  style?: any; // Inline CSS styling
}
export interface AzureImageWithOptionsProps extends AzureImageProps {
  fileName: string; // filename.png
  container? : string; // Azure Storage container
  folderPath?: string; // folder/containing/file/
}

const ImageFromAzureWithOptions = ({
  alt,
  fileName,
  container = null,
  folderPath = null,
  className = null,
  id = null,
  style = null,
}: AzureImageWithOptionsProps) : JSX.Element => {
  const [imgSrc, setImgSrc] = useState(null);
  function onError (err: AxiosError) {
    console.error('ImageFromAzure: ', err.message);
  }
  function onSuccess (res: AxiosResponse) {
    const data: AzureImageResponseType = res.data;
    if (data.status === 'OK') {
      const dataUrl = formatDataUrlWithUrl(data.dataUrl, data.url);
      setImgSrc(dataUrl);
    } else {
      console.warn('ImageFromAzure: ', data.message);
    }
  }
  useEffect(() => {
    if (fileName) {
      getImageWithOptions({
        fileName,
        opts: {
          container,
          folderPath,
          onError,
          onSuccess,
        },
      });
    } else {
      // If no fileUri or fileName sent, log error.
      console.error('<ImageFromAzure>: Required data is undefined.');
    }
  }, []);

  return (
    <img id={id} src={imgSrc} alt={alt} className={className} style={style} />
  );
};

export default ImageFromAzureWithOptions;
